const normalizeAlphaNumLower = (value) => {
  const input = String(value || '').trim().toLowerCase();
  if (!input) return '';
  let out = '';
  for (const char of input) {
    const code = char.codePointAt(0);
    const isDigit = code >= 48 && code <= 57;
    const isLower = code >= 97 && code <= 122;
    if (isDigit || isLower) out += char;
  }
  return out;
};

const keepNumberChars = (value) => {
  const input = String(value || '').trim();
  if (!input) return '';
  let out = '';
  for (const ch of input) {
    const isDigit = ch >= '0' && ch <= '9';
    if (isDigit || ch === '.' || ch === '-') out += ch;
  }
  return out.trim();
};

export { normalizeAlphaNumLower, keepNumberChars };
